webpackJsonp([12],{

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var namespace = exports.namespace = 'grommetux-';

exports.default = {
  ACCORDION: namespace + 'accordion',
  ACCORDION_PANEL: namespace + 'accordion-panel',
  ANCHOR: namespace + 'anchor',
  ANIMATE: namespace + 'animate',
  APP: namespace + 'app',
  ARTICLE: namespace + 'article',
  ATTRIBUTE: namespace + 'attribute',
  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
  BOX: namespace + 'box',
  BORDER_COLOR_INDEX: namespace + 'border-color-index',
  BRICK: namespace + 'brick',
  BUTTON: namespace + 'button',
  CALENDAR: namespace + 'calendar',
  CARD: namespace + 'card',
  CAROUSEL: namespace + 'carousel',
  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
  CHART: namespace + 'chart',
  CHART_AXIS: namespace + 'chart-axis',
  CHART_BASE: namespace + 'chart-base',
  CHART_GRAPH: namespace + 'chart-graph',
  CHART_GRID: namespace + 'chart-grid',
  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
  CHART_LAYERS: namespace + 'chart-layers',
  CHART_MARKER: namespace + 'chart-marker',
  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
  CHART_RANGE: namespace + 'chart-range',
  CHECK_BOX: namespace + 'check-box',
  COLLAPSIBLE: namespace + 'collapsible',
  COLOR_INDEX: namespace + 'color-index',
  COLUMNS: namespace + 'columns',
  CONTROL_ICON: namespace + 'control-icon',
  DATE_TIME: namespace + 'date-time',
  DATE_TIME_DROP: namespace + 'date-time-drop',
  DISTRIBUTION: namespace + 'distribution',
  DROP: namespace + 'drop',
  FOOTER: namespace + 'footer',
  FORM: namespace + 'form',
  FORM_FIELD: namespace + 'form-field',
  FORM_FIELDS: namespace + 'form-fields',
  HEADER: namespace + 'header',
  HEADING: namespace + 'heading',
  HEADLINE: namespace + 'headline',
  HERO: namespace + 'hero',
  IMAGE: namespace + 'image',
  IMAGE_FIELD: namespace + 'image-field',
  INPUT: namespace + 'input',
  LABEL: namespace + 'label',
  LAYER: namespace + 'layer',
  LEGEND: namespace + 'legend',
  LIST: namespace + 'list',
  LIST_ITEM: namespace + 'list-item',
  LOGIN: namespace + 'login',
  LOGIN_FORM: namespace + 'login-form',
  LOGO_ICON: namespace + 'logo-icon',
  MAP: namespace + 'map',
  MENU: namespace + 'menu',
  METER: namespace + 'meter',
  NAMESPACE: '' + namespace,
  NOTIFICATION: namespace + 'notification',
  NUMBER_INPUT: namespace + 'number-input',
  OBJECT: namespace + 'object',
  PARAGRAPH: namespace + 'paragraph',
  PASSWORD_INPUT: namespace + 'password-input',
  PULSE: namespace + 'pulse',
  QUOTE: namespace + 'quote',
  RADIO_BUTTON: namespace + 'radio-button',
  SEARCH: namespace + 'search',
  SEARCH_INPUT: namespace + 'search-input',
  SECTION: namespace + 'section',
  SELECT: namespace + 'select',
  SIDEBAR: namespace + 'sidebar',
  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
  SKIP_LINKS: namespace + 'skip-links',
  SPLIT: namespace + 'split',
  SPINNING: namespace + 'icon-spinning',
  STATUS_ICON: namespace + 'status-icon',
  SUN_BURST: namespace + 'sun-burst',
  TAB: namespace + 'tab',
  TABLE: namespace + 'table',
  TABLE_ROW: namespace + 'table-row',
  TABS: namespace + 'tabs',
  TAG: namespace + 'tag',
  TAGS: namespace + 'tags',
  TBD: namespace + 'tbd',
  TEXT_INPUT: namespace + 'text-input',
  TILE: namespace + 'tile',
  TILES: namespace + 'tiles',
  TIMESTAMP: namespace + 'timestamp',
  TIP: namespace + 'tip',
  TITLE: namespace + 'title',
  TOAST: namespace + 'toast',
  TOPOLOGY: namespace + 'topology',
  VALUE: namespace + 'value',
  VIDEO: namespace + 'video',
  WORLD_MAP: namespace + 'world-map'
};

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(18);

var _DOM = __webpack_require__(511);

// Allow callers to use key labels instead of key code numbers.
// This makes their code easier to read.
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var KEYS = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  comma: 188,
  shift: 16
};

var _keyboardAccelerators = {};
var _listeners = [];
var _isKeyboardAcceleratorListening = false;

var _onKeyboardAcceleratorKeyPress = function _onKeyboardAcceleratorKeyPress(e) {
  var key = e.keyCode ? e.keyCode : e.which;
  _listeners.slice().reverse().some(function (listener) {
    if (_keyboardAccelerators[listener]) {
      var handlers = _keyboardAccelerators[listener].handlers;
      if (handlers.hasOwnProperty(key)) {
        if (handlers[key] && handlers[key](e)) {
          return true;
        }
      }
    }
    return false;
  });
};

// KeyboardAccelerators is a utility for handling keyboard events.
// Add listeners using startListeningToKeyboard().
// Remove listeners using stopListeningToKeyboard().
exports.default = {
  _initKeyboardAccelerators: function _initKeyboardAccelerators(element) {
    var id = (0, _DOM.generateId)(element);
    _keyboardAccelerators[id] = {
      handlers: {}
    };
  },
  _getKeyboardAcceleratorHandlers: function _getKeyboardAcceleratorHandlers(element) {
    var id = (0, _DOM.generateId)(element);
    return _keyboardAccelerators[id].handlers;
  },
  _getDowns: function _getDowns(element) {
    var id = (0, _DOM.generateId)(element);
    return _keyboardAccelerators[id].downs;
  },
  _isComponentListening: function _isComponentListening(element) {
    var id = (0, _DOM.generateId)(element);

    return _listeners.some(function (listener) {
      return listener === id;
    });
  },
  _subscribeComponent: function _subscribeComponent(element) {
    var id = (0, _DOM.generateId)(element);
    _listeners.push(id);
  },
  _unsubscribeComponent: function _unsubscribeComponent(element) {
    var id = (0, _DOM.generateId)(element);

    var removeListenerIndex = _listeners.indexOf(id);
    _listeners.splice(removeListenerIndex, 1);

    delete _keyboardAccelerators[id];
  },


  // Add handlers for specific keys.
  // This function can be called multiple times, existing handlers will
  // be replaced, new handlers will be added.
  startListeningToKeyboard: function startListeningToKeyboard(component, handlers) {
    var element = (0, _reactDom.findDOMNode)(component);
    if (element) {
      this._initKeyboardAccelerators(element);
      var keys = 0;
      for (var key in handlers) {
        if (handlers.hasOwnProperty(key)) {
          var keyCode = key;
          if (KEYS.hasOwnProperty(key)) {
            keyCode = KEYS[key];
          }
          keys += 1;
          this._getKeyboardAcceleratorHandlers(element)[keyCode] = handlers[key];
        }
      }

      if (keys > 0) {
        if (!_isKeyboardAcceleratorListening) {
          window.addEventListener("keydown", _onKeyboardAcceleratorKeyPress);
          _isKeyboardAcceleratorListening = true;
        }
        if (!this._isComponentListening(element)) {
          this._subscribeComponent(element);
        }
      }
    }
  },


  // Remove handlers for all keys or specific keys.
  // If no argument is passed in, all handlers are removed.
  // This function can be called multiple times, only the handlers
  // specified will be removed.
  stopListeningToKeyboard: function stopListeningToKeyboard(component, handlers) {
    var element = (0, _reactDom.findDOMNode)(component);
    if (!this._isComponentListening(element)) {
      return;
    }
    if (handlers) {
      for (var key in handlers) {
        if (handlers.hasOwnProperty(key)) {
          var keyCode = key;
          if (KEYS.hasOwnProperty(key)) {
            keyCode = KEYS[key];
          }
          delete this._getKeyboardAcceleratorHandlers(element)[keyCode];
        }
      }
    }

    var keyCount = 0;
    for (var keyHandler in this._getKeyboardAcceleratorHandlers(element)) {
      if (this._getKeyboardAcceleratorHandlers(element).hasOwnProperty(keyHandler)) {
        keyCount += 1;
      }
    }

    if (!handlers || 0 === keyCount) {
      this._initKeyboardAccelerators(element);
      this._unsubscribeComponent(element);
    }

    if (_listeners.length === 0) {
      window.removeEventListener("keydown", _onKeyboardAcceleratorKeyPress);
      _isKeyboardAcceleratorListening = false;
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.findScrollParents = findScrollParents;
exports.isDescendant = isDescendant;
exports.findAncestor = findAncestor;
exports.filterByFocusable = filterByFocusable;
exports.getBestFirstFocusable = getBestFirstFocusable;
exports.isFormElement = isFormElement;
exports.generateId = generateId;
exports.generateUUID = generateUUID;
exports.checkDarkBackground = checkDarkBackground;
exports.findVisibleParent = findVisibleParent;
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var COLOR_RGB_REGEXP = /rgb\((\d+), (\d+), (\d+)\)/;
var COLOR_RGBA_REGEXP = /rgba\((\d+), (\d+), (\d+), ([\d\.]+)\)/;
var LIGHT_HINT_REGEXP = /^light/;

function hash(input) {
  var hash = 0,
      i,
      chr,
      len;
  if (input.length === 0) return hash;
  for (i = 0, len = input.length; i < len; i++) {
    chr = input.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

function findScrollParents(element, horizontal) {
  var result = [];
  var parent = element.parentNode;
  while (parent && parent.getBoundingClientRect) {
    var rect = parent.getBoundingClientRect();
    // 10px is to account for borders and scrollbars in a lazy way
    if (horizontal) {
      if (rect.width && parent.scrollWidth > rect.width + 10) {
        result.push(parent);
      }
    } else {
      if (rect.height && parent.scrollHeight > rect.height + 10) {
        result.push(parent);
      }
    }
    parent = parent.parentNode;
  }
  // last scrollable element will be the document
  // if nothing else is scrollable in the page
  if (result.length === 0) {
    result.push(document);
  }
  return result;
}

function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

function findAncestor(element, className) {
  var node = element.parentNode;
  while (node != null) {
    if (node.classList && node.classList.contains(className)) {
      break;
    }
    node = node.parentNode;
  }
  return node;
}

function filterByFocusable(elements) {
  return Array.prototype.filter.call(elements || [], function (element) {
    var currentTag = element.tagName.toLowerCase();
    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
    var isValidTag = currentTag.match(validTags) && element.focus;

    if (currentTag === 'a') {
      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
    } else if (currentTag === 'svg' || currentTag === 'div') {
      return isValidTag && element.hasAttribute('tabindex');
    }

    return isValidTag;
  });
}

function getBestFirstFocusable(elements) {
  var bestFirstFocusable;

  Array.prototype.some.call(elements || [], function (element) {
    var currentTag = element.tagName.toLowerCase();
    var isValidTag = currentTag.match(/(input|select|textarea)$/);
    return isValidTag ? (bestFirstFocusable = element, true) : false;
  });

  if (!bestFirstFocusable) {
    bestFirstFocusable = this.filterByFocusable(elements)[0];
  }

  return bestFirstFocusable;
}

function isFormElement(element) {
  var elementType = element ? element.tagName.toLowerCase() : undefined;
  return elementType && (elementType === 'input' || elementType === 'textarea');
}

function generateId(element) {
  if (element && typeof element.getAttribute === 'function') {
    var id = void 0;
    var elementId = element.getAttribute('id');
    if (!elementId) {
      // IE11 fix: check for parentNode instead of parentElement
      var parentElement = element.parentElement || element.parentNode;
      if (parentElement) {
        id = hash(parentElement.innerHTML);
        element.setAttribute('id', id);
      }
    } else {
      id = elementId;
    }
    return id;
  }
}

function generateUUID() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  var uuid = '' + S4() + S4() + ('-' + S4() + '-4' + S4().substr(0, 3)) + ('-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
  return uuid;
}

var CHECK_DARK_BACKGROUND_BACKOFFS = [0, 20, 80, 200];

function hasDarkBackground(element) {
  var result = false;
  var color = window.getComputedStyle(element).backgroundColor;
  var match = color.match(COLOR_RGB_REGEXP) || color.match(COLOR_RGBA_REGEXP);
  if (match) {
    var _match$slice$map = match.slice(1).map(function (n) {
      return parseInt(n, 10);
    }),
        _match$slice$map2 = _slicedToArray(_match$slice$map, 3),
        red = _match$slice$map2[0],
        green = _match$slice$map2[1],
        blue = _match$slice$map2[2];
    // http://www.had2know.com/technology/
    //  color-contrast-calculator-web-design.html


    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
    if (0 === brightness) {
      // Browsers return 0,0,0 when they don't know yet.
      result = undefined;
      // changed threshold below to accomodate the Aruba theme for now
    } else if (brightness < 137) {
      ///125) {
      result = true;
    }
  }
  return result;
}

function checkDarkBackgroundBackoff(element, handler, backoffDurations) {
  return setTimeout(function () {
    var dark = hasDarkBackground(element);
    if (undefined === dark && backoffDurations.length > 0) {
      checkDarkBackgroundBackoff(element, handler, backoffDurations);
    } else {
      handler(dark);
    }
  }, backoffDurations.shift());
}

function checkDarkBackground(colorIndex, element, handler) {
  var timer = void 0;
  if (colorIndex) {
    if ('dark' === colorIndex) {
      // caller knows
      handler(true);
    } else if (LIGHT_HINT_REGEXP.test(colorIndex)) {
      // skip if this is a 'light-*' color index
      handler(false);
    } else {
      // Measure the actual background color brightness to determine whether
      // to set a dark or light context.
      if (element && window.getComputedStyle) {
        timer = checkDarkBackgroundBackoff(element, handler, CHECK_DARK_BACKGROUND_BACKOFFS);
      }
    }
  }
  return { stop: function stop() {
      return clearTimeout(timer);
    } };
}

function findVisibleParent(element) {
  if (element) {
    return element.offsetParent ? element : findVisibleParent(element.parentElement);
  } else {
    return null;
  }
}

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(69);

var _classnames4 = _interopRequireDefault(_classnames3);

var _CSSClassnames = __webpack_require__(486);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _KeyboardAccelerators = __webpack_require__(510);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.WORLD_MAP;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

// The graphic is drawn as a rectangular grid using coordinates spaced
// by FACTOR pixels. The contents have both an area boundary for interaction
// and dots described as rows where each row is described by three values:
// a starting coordinate and a length. This approach is more efficient than
// describing it via SVG elements, keeping the code/library size smaller.
var CONTINENTS = [{
  id: 'Australia',
  origin: [74, 32],
  area: [[4, 0], [7, 1], [15, 7], [13, 9], [0, 6], [0, 2]],
  dots: [[4, 0, 1], [2, 1, 6], [0, 2, 9], [0, 3, 10], [0, 4, 10], [0, 5, 3], [5, 5, 5], [5, 6, 4], [15, 7, 1], [14, 8, 1], [13, 9, 1]]
}, {
  id: 'Asia',
  origin: [52, 1],
  area: [[16, 0], [38, 5], [40, 7], [28, 17], [24, 25], [29, 29], [19, 29], [11, 24], [3, 23], [0, 20], [0, 19], [6, 13], [7, 6]],
  dots: [[16, 0, 1], [17, 1, 2], [18, 2, 2], [15, 3, 6], [28, 3, 1], [30, 3, 1], [10, 4, 2], [13, 4, 10], [24, 4, 1], [9, 5, 22], [32, 5, 1], [38, 5, 1], [7, 6, 2], [10, 6, 1], [12, 6, 27], [7, 7, 34], [7, 8, 31], [7, 9, 26], [34, 9, 3], [7, 10, 22], [31, 10, 1], [33, 10, 1], [7, 11, 21], [32, 11, 2], [7, 12, 21], [32, 12, 1], [6, 13, 22], [32, 13, 1], [6, 14, 22], [5, 15, 22], [3, 16, 2], [6, 16, 20], [2, 17, 3], [6, 17, 16], [24, 17, 1], [28, 17, 1], [1, 18, 22], [26, 18, 2], [0, 19, 24], [0, 20, 5], [6, 20, 17], [2, 21, 5], [10, 21, 14], [2, 22, 5], [11, 22, 4], [16, 22, 4], [3, 23, 3], [11, 23, 2], [17, 23, 3], [23, 23, 1], [11, 24, 2], [18, 24, 2], [23, 24, 1], [24, 25, 1], [18, 26, 1], [22, 26, 1], [18, 27, 1], [20, 27, 4], [18, 28, 1], [21, 28, 1], [23, 28, 1], [26, 28, 3], [19, 29, 1], [28, 29, 2]]
}, {
  // 21X, 40Y
  id: 'Africa',
  origin: [40, 19],
  area: [[3, 0], [6, 0], [11, 2], [16, 7], [16, 15], [11, 18], [9, 18], [0, 6], [0, 3]],
  dots: [[3, 0, 4], [2, 1, 6], [9, 1, 2], [1, 2, 11], [0, 3, 13], [0, 4, 14], [0, 5, 14], [0, 6, 16], [1, 7, 16], [2, 8, 2], [6, 8, 11], [7, 9, 9], [7, 10, 8], [7, 11, 7], [8, 12, 7], [7, 13, 8], [7, 14, 7], [16, 14, 1], [8, 15, 5], [15, 15, 2], [8, 16, 5], [9, 17, 3], [9, 18, 3]]
}, {
  id: 'Europe',
  origin: [39, 2],
  area: [[8, 0], [10, 0], [20, 2], [19, 11], [18, 13], [14, 16], [3, 16], [0, 7]],
  dots: [[8, 0, 3], [9, 1, 1], [20, 2, 1], [19, 3, 1], [12, 4, 1], [19, 4, 1], [9, 5, 6], [9, 6, 7], [17, 6, 3], [0, 7, 1], [8, 7, 12], [7, 8, 3], [11, 8, 9], [7, 9, 3], [11, 9, 9], [4, 10, 1], [7, 10, 1], [9, 10, 1], [11, 10, 9], [3, 11, 2], [7, 11, 13], [4, 12, 1], [6, 12, 13], [4, 13, 15], [5, 14, 3], [9, 14, 4], [15, 14, 2], [3, 15, 3], [8, 15, 1], [10, 15, 5], [6, 15, 2], [3, 16, 2], [10, 16, 5]]
}, {
  id: 'SouthAmerica',
  origin: [22, 26],
  area: [[2, 0], [5, 0], [11, 4], [11, 8], [3, 18], [2, 17], [0, 4], [0, 3]],
  dots: [[2, 0, 4], [1, 1, 7], [1, 2, 7], [0, 3, 10], [0, 4, 12], [1, 5, 11], [2, 6, 9], [3, 7, 8], [3, 8, 8], [3, 9, 6], [3, 10, 6], [3, 11, 5], [3, 12, 3], [2, 13, 3], [2, 14, 3], [2, 15, 2], [2, 16, 2], [2, 17, 2], [3, 18, 1]]
}, {
  id: 'NorthAmerica',
  origin: [0, 0],
  area: [[21, 0], [39, 0], [39, 6], [22, 26], [16, 23], [2, 12], [0, 7]],
  dots: [[22, 0, 6], [29, 0, 1], [31, 0, 1], [33, 0, 5], [20, 1, 1], [22, 1, 1], [24, 1, 2], [27, 1, 13], [17, 2, 1], [20, 2, 5], [26, 2, 13], [13, 3, 1], [19, 3, 1], [21, 3, 3], [26, 3, 14], [14, 4, 1], [16, 4, 4], [21, 4, 3], [29, 4, 11], [12, 5, 3], [16, 5, 1], [18, 5, 1], [20, 5, 3], [24, 5, 1], [30, 5, 8], [14, 6, 3], [19, 6, 1], [22, 6, 4], [31, 6, 8], [0, 7, 15], [16, 7, 1], [18, 7, 4], [24, 7, 2], [30, 7, 7], [2, 8, 20], [24, 8, 3], [29, 8, 5], [2, 9, 20], [24, 9, 2], [30, 9, 3], [1, 10, 18], [23, 10, 2], [31, 10, 1], [2, 11, 2], [8, 11, 11], [23, 11, 2], [26, 11, 1], [2, 12, 1], [8, 12, 13], [24, 12, 3], [10, 13, 12], [23, 13, 5], [11, 14, 17], [11, 15, 9], [21, 15, 6], [28, 15, 2], [11, 16, 11], [23, 16, 4], [11, 17, 14], [12, 18, 11], [12, 19, 12], [13, 20, 9], [15, 21, 3], [22, 21, 1], [16, 22, 2], [16, 23, 2], [20, 23, 1], [23, 23, 1], [18, 24, 3], [21, 25, 1], [22, 26, 1]]
}];

// FACTOR is the distance in pixels between coordinates
var FACTOR = 10;

// helper function to detect if any series elements have
var clickableSeries = function clickableSeries(props) {
  return props.series && props.series.some(function (serie) {
    return serie.onClick;
  });
};

var maxCoordinate = function maxCoordinate(a, b) {
  return [Math.max(a[0], b[0]), Math.max(a[1], b[1])];
};
var minCoordinate = function minCoordinate(a, b) {
  return [Math.min(a[0], b[0]), Math.min(a[1], b[1])];
};

// Based on https://stackoverflow.com/a/43861247
var MAP_LAT_BOTTOM = -50.0; // empirically determined
var MAP_LAT_BOTTOM_RAD = MAP_LAT_BOTTOM * Math.PI / 180;
var MAP_LON_LEFT = -171.0; // empirically determined
var MAP_LON_RIGHT = 184.0; // empirically determined
var MAP_LON_DELTA = MAP_LON_RIGHT - MAP_LON_LEFT;

var mapValues = function mapValues(extent) {
  var mapRadius = extent[0] / MAP_LON_DELTA * 360 / (2 * Math.PI);
  var mapOffsetY = Math.round(mapRadius / 2 * Math.log((1 + Math.sin(MAP_LAT_BOTTOM_RAD)) / (1 - Math.sin(MAP_LAT_BOTTOM_RAD))));
  return { mapRadius: mapRadius, mapOffsetY: mapOffsetY };
};

var latLonToCoord = function latLonToCoord(latLon, origin, extent) {
  var _mapValues = mapValues(extent),
      mapRadius = _mapValues.mapRadius,
      mapOffsetY = _mapValues.mapOffsetY;

  var x = Math.round((latLon[1] - MAP_LON_LEFT) * extent[0] / MAP_LON_DELTA);
  var latitudeRad = latLon[0] * Math.PI / 180;
  var y = extent[1] + mapOffsetY - Math.round(mapRadius / 2 * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad))));
  return [x, y]; // the coordinate value of this point on the map image
};

var coordToLatLon = function coordToLatLon(coord, origin, extent) {
  var _mapValues2 = mapValues(extent),
      mapRadius = _mapValues2.mapRadius,
      mapOffsetY = _mapValues2.mapOffsetY;

  var a = (extent[1] + mapOffsetY - coord[1]) / mapRadius;
  var lat = 180 / Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI / 2);
  var lon = coord[0] * MAP_LON_DELTA / extent[0] + MAP_LON_LEFT;
  return [lat, lon];
};

var WorldMap = function (_Component) {
  _inherits(WorldMap, _Component);

  function WorldMap(props, context) {
    _classCallCheck(this, WorldMap);

    var _this = _possibleConstructorReturn(this, (WorldMap.__proto__ || Object.getPrototypeOf(WorldMap)).call(this, props, context));

    _this._renderPlace = _this._renderPlace.bind(_this);
    _this._activateContinent = _this._activateContinent.bind(_this);
    _this._activatePlace = _this._activatePlace.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._onMouseOver = _this._onMouseOver.bind(_this);
    _this._onMouseMove = _this._onMouseMove.bind(_this);
    _this._onMouseLeave = _this._onMouseLeave.bind(_this);

    _this.state = _this._buildState();
    _this.state = _extends({}, _this.state, _this._updateState(props));
    _this.state.clickable = clickableSeries(props);
    _this._flagRefs = {};
    return _this;
  }

  _createClass(WorldMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var clickable = this.state.clickable;

      if (clickable) {
        this._startKeyboardListening();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, this._updateState(nextProps)));

      var clickable = this.state.clickable;

      var nextClickable = clickableSeries(nextProps);
      if (nextClickable !== clickable) {
        if (nextClickable) {
          this._startKeyboardListening();
        } else {
          this._stopKeyboardListening();
        }
        this.setState({ clickable: nextClickable });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      // place flags
      var series = this.props.series;
      var _state = this.state,
          continents = _state.continents,
          places = _state.places,
          zoomedOrigin = _state.zoomedOrigin,
          width = _state.width;

      var flagged = (series || []).filter(function (s) {
        return s.flag;
      });
      if (flagged.length > 0) {
        var rect = this._worldMapRef.getBoundingClientRect();
        var scale = rect.width / width;
        flagged.forEach(function (serie, index) {
          var placeState = places[index];
          var x = void 0;
          var y = void 0;
          if (serie.continent) {
            var continentState = continents[serie.continent];
            x = (continentState.mid[0] - zoomedOrigin[0]) * FACTOR * scale;
            y = (continentState.mid[1] - zoomedOrigin[1]) * FACTOR * scale;
          } else if (serie.place) {
            x = placeState.place[0] * FACTOR * scale;
            y = placeState.place[1] * FACTOR * scale;
          }
          var flag = _this2._flagRefs[index];
          var flagRect = flag.getBoundingClientRect();
          var xOffset = x > rect.width / 2 ? FACTOR / 2 : -(flagRect.width + FACTOR / 2);
          var yOffset = y > rect.height / 2 ? FACTOR / 2 : -(flagRect.height + FACTOR / 2);
          flag.style.top = y + yOffset + 'px';
          flag.style.left = x + xOffset + 'px';
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clickable = this.state.clickable;

      if (clickable) {
        this._stopKeyboardListening();
      }
    }
  }, {
    key: '_buildState',
    value: function _buildState() {
      var state = {
        activeContinent: undefined, activePlace: undefined, continents: {}
      };

      // Build the SVG paths describing the individual dots
      var totalExtent = [0, 0];
      CONTINENTS.forEach(function (continent) {
        var origin = continent.origin;

        var extent = [].concat(_toConsumableArray(origin));
        var dots = continent.dots.map(function (segment) {
          var dots = Array.apply(null, Array(segment[2])).map(function () {
            return 'h0';
          }).join(' m10,0 ');
          var x = FACTOR * (origin[0] + segment[0] + 1);
          var y = FACTOR * (origin[1] + segment[1] + 1);
          extent = maxCoordinate(extent, [origin[0] + segment[0] + segment[2], origin[1] + segment[1]]);
          return 'M' + x + ',' + y + ' ' + dots;
        }).join(' ');

        var area = continent.area.map(function (point, index) {
          var x = FACTOR * (point[0] + origin[0] + 1);
          var y = FACTOR * (point[1] + origin[1] + 1);
          return '' + (index === 0 ? 'M' : 'L') + x + ',' + y;
        }).join(' ') + ' Z';

        var mid = [origin[0] + (extent[0] - origin[0]) / 2, origin[1] + (extent[1] - origin[1]) / 2];
        state.continents[continent.id] = { area: area, dots: dots, origin: origin, extent: extent, mid: mid };
        totalExtent = maxCoordinate(totalExtent, extent);
      });

      state.origin = [0, 0];
      state.extent = totalExtent;

      return state;
    }
  }, {
    key: '_updateState',
    value: function _updateState(props) {
      var _this3 = this;

      var series = props.series,
          zoom = props.zoom;

      var continents = _extends({}, this.state.continents);

      // convert places using lat,lon
      var places = (series || []).filter(function (s) {
        return s.place;
      }).map(function (serie) {
        var place = serie.place;
        if (place[0] % 1) {
          place = latLonToCoord(place, _this3.state.origin, _this3.state.extent);
        }
        return { place: place, id: place.join(',') };
      });

      // update how much of the map to show
      var haveSomeContinents = (series || []).filter(function (s) {
        return s.continent;
      }).length > 0;
      var origin = [].concat(_toConsumableArray(this.state.extent));
      var extent = [].concat(_toConsumableArray(this.state.origin));
      CONTINENTS.forEach(function (continent) {
        var continentState = continents[continent.id];
        var serie = (series || []).filter(function (s) {
          return s.continent === continent.id;
        })[0];
        // see if any places are within the continent
        var includedPlaces = places.filter(function (s) {
          return s.place[0] >= continentState.origin[0] && s.place[0] <= continentState.extent[0] && s.place[1] >= continentState.origin[1] && s.place[1] <= continentState.extent[1];
        });
        var visible = !haveSomeContinents && !zoom || serie || includedPlaces.length > 0;
        if (visible || !zoom) {
          origin = minCoordinate(origin, continentState.origin);
          extent = maxCoordinate(extent, continentState.extent);
        }
        continents[continent.id].visible = visible;
        continents[continent.id].serie = serie;
      });

      return {
        continents: continents,
        places: places,
        zoomedOrigin: origin,
        x: origin[0] * FACTOR, y: origin[1] * FACTOR,
        width: (extent[0] - origin[0] + 1) * FACTOR,
        height: (extent[1] - origin[1] + 2) * FACTOR
      };
    }
  }, {
    key: '_startKeyboardListening',
    value: function _startKeyboardListening() {
      this._keyboardHandlers = {
        enter: this._onEnter,
        space: this._onEnter
      };
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
    }
  }, {
    key: '_stopKeyboardListening',
    value: function _stopKeyboardListening() {
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
    }
  }, {
    key: '_activateContinent',
    value: function _activateContinent(activeContinent) {
      this.setState({ activeContinent: activeContinent });
    }
  }, {
    key: '_activatePlace',
    value: function _activatePlace(activePlace) {
      this.setState({ activePlace: activePlace });
    }
  }, {
    key: '_onEnter',
    value: function _onEnter() {
      var series = this.props.series;
      var _state2 = this.state,
          activeContinent = _state2.activeContinent,
          activePlace = _state2.activePlace;

      if (this._worldMapRef.contains(document.activeElement)) {
        series.some(function (serie) {
          if (activeContinent && serie.continent === activeContinent || activePlace && serie.place.join(',') === activePlace.join(',')) {
            if (serie.onClick) {
              serie.onClick();
            }
            return true;
          }
          return false;
        });
      }
    }
  }, {
    key: '_onMouseOver',
    value: function _onMouseOver() {
      // track when we're over the map to avoid dealing with mouse moves
      this.setState({ over: true });
    }
  }, {
    key: '_onMouseMove',
    value: function _onMouseMove(event) {
      var width = this.state.width;
      // determine the map coordinates for where the mouse is

      var rect = this._worldMapRef.getBoundingClientRect();
      var scale = rect.width / width; // since the SVG viewBox might be scaled
      var place = [Math.round((event.clientX - rect.left) / scale / FACTOR), Math.round((event.clientY - rect.top) / scale / FACTOR)];
      this.setState({ activePlace: place });
    }
  }, {
    key: '_onMouseLeave',
    value: function _onMouseLeave() {
      this.setState({ over: false, activePlace: undefined });
    }
  }, {
    key: '_interactiveProps',
    value: function _interactiveProps(serie, defaultLabel, activeFunc, activeValue, active) {
      return {
        role: 'button',
        'aria-label': serie.label || defaultLabel,
        tabIndex: '0',
        onClick: serie.onClick,
        onMouseOver: function onMouseOver() {
          if (!active) {
            activeFunc(activeValue);
            if (serie.onHover) {
              serie.onHover(true);
            }
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (active) {
            activeFunc(undefined);
            if (serie.onHover) {
              serie.onHover(false);
            }
          }
        },
        onFocus: function onFocus() {
          // This moves the map unnecessarily. Instead, we should check
          // the position and scroll if it isn't already visible
          // this._worldMapRef.scrollIntoView();
          if (!active) {
            activeFunc(activeValue);
          }
        },
        onBlur: function onBlur() {
          if (active) {
            activeFunc(undefined);
          }
        }
      };
    }
  }, {
    key: '_renderContinent',
    value: function _renderContinent(continent, index, mapColorIndex, serie) {
      var _state3 = this.state,
          activeContinent = _state3.activeContinent,
          continents = _state3.continents;

      var active = continent.id === activeContinent;
      // only graph color if they explicitly asked for this continent
      var colorIndex = (serie || {}).colorIndex || mapColorIndex || (serie ? 'graph-' + index : 'light-2');

      var classes = (0, _classnames4.default)(CLASS_ROOT + '__continent', COLOR_INDEX + '-' + colorIndex, _defineProperty({}, CLASS_ROOT + '__continent--active', active));
      var area = void 0;
      var interactiveProps = {};
      if (serie && (serie.onClick || serie.onHover)) {
        area = _react2.default.createElement('path', { stroke: 'none', fill: '#fff', fillOpacity: '0.01',
          d: continents[continent.id].area });
        interactiveProps = this._interactiveProps(serie, continent.id, this._activateContinent, continent.id, active);
      }
      // We add the area so the mouse events work for the whole region,
      // not just the dots
      return _react2.default.createElement(
        'g',
        _extends({ key: continent.id, className: classes }, interactiveProps),
        area,
        _react2.default.createElement('path', { d: continents[continent.id].dots })
      );
    }
  }, {
    key: '_renderPlace',
    value: function _renderPlace(serie, index) {
      var mapColorIndex = this.props.colorIndex;
      var _state4 = this.state,
          activePlace = _state4.activePlace,
          places = _state4.places;

      var serieColorIndex = serie.colorIndex,
          onClick = serie.onClick,
          onHover = serie.onHover,
          place = serie.place,
          rest = _objectWithoutProperties(serie, ['colorIndex', 'onClick', 'onHover', 'place']);

      delete rest.flag;
      var placeState = places[index];
      var active = activePlace && activePlace.join(',') === placeState.id;
      var colorIndex = serieColorIndex || mapColorIndex || 'graph-' + index;
      var classes = (0, _classnames4.default)(CLASS_ROOT + '__place', COLOR_INDEX + '-' + colorIndex, _defineProperty({}, CLASS_ROOT + '__place--active', active));
      var d = 'M' + FACTOR * placeState.place[0] + ',' + FACTOR * placeState.place[1] + ' h0';
      var interactiveProps = {};
      if (onClick || onHover) {
        interactiveProps = this._interactiveProps(serie, 'place', this._activatePlace, place, active);
      }
      return _react2.default.createElement('path', _extends({ key: place.join(',') + '__' + index }, rest, { className: classes
      }, interactiveProps, { d: d }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex,
          onSelectPlace = _props.onSelectPlace,
          series = _props.series,
          props = _objectWithoutProperties(_props, ['className', 'colorIndex', 'onSelectPlace', 'series']);

      delete props.zoom;
      var _state5 = this.state,
          activePlace = _state5.activePlace,
          over = _state5.over,
          x = _state5.x,
          y = _state5.y,
          width = _state5.width,
          height = _state5.height,
          origin = _state5.origin,
          extent = _state5.extent;

      var classes = (0, _classnames4.default)(CLASS_ROOT, className);

      var continents = [];
      CONTINENTS.forEach(function (continent, index) {
        var continentState = _this4.state.continents[continent.id];
        if (continentState.visible) {
          var serie = continentState.serie;
          continents.push(_this4._renderContinent(continent, index, colorIndex, serie));
        }
      });

      var seriesPlaces = (series || []).filter(function (s) {
        return s.place;
      });
      var placesGroup = void 0;
      if (seriesPlaces.length > 0) {
        var places = seriesPlaces.map(this._renderPlace);
        placesGroup = _react2.default.createElement(
          'g',
          { stroke: 'none', fill: 'none', fillRule: 'evenodd' },
          places
        );
      }

      // If the caller is interested in onSelectPlace changes, track where the
      // user goes.
      var interactiveProps = {};
      var activeGroup = void 0;
      if (onSelectPlace) {
        interactiveProps = {
          onMouseOver: this._onMouseOver,
          onMouseMove: over ? this._onMouseMove : undefined,
          onMouseLeave: this._onMouseLeave
        };

        if (activePlace) {
          var _classes = (0, _classnames4.default)(CLASS_ROOT + '__place', COLOR_INDEX + '-' + (colorIndex || 'light-2'), CLASS_ROOT + '__place--active');
          var d = 'M' + FACTOR * activePlace[0] + ',' + FACTOR * activePlace[1] + ' h0';
          activeGroup = _react2.default.createElement(
            'g',
            { stroke: 'none', fill: 'none', fillRule: 'evenodd',
              onClick: function onClick() {
                return onSelectPlace(activePlace, coordToLatLon(activePlace, origin, extent));
              } },
            _react2.default.createElement('path', { className: _classes, d: d })
          );
        }
      }

      var contents = _react2.default.createElement(
        'svg',
        _extends({}, props, interactiveProps, {
          ref: function ref(_ref) {
            return _this4._worldMapRef = _ref;
          },
          className: classes, version: '1.1',
          preserveAspectRatio: 'xMidYMin slice',
          width: width + 'px',
          viewBox: x + ' ' + y + ' ' + width + ' ' + height }),
        _react2.default.createElement(
          'g',
          { stroke: 'none', fill: 'none', fillRule: 'evenodd' },
          continents
        ),
        activeGroup,
        placesGroup
      );

      var flagged = (series || []).filter(function (s) {
        return s.flag;
      });
      if (flagged.length > 0) {
        contents = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__container' },
          contents,
          flagged.map(function (serie, index) {
            return _react2.default.createElement(
              'div',
              { key: index, className: CLASS_ROOT + '__flag',
                ref: function ref(_ref2) {
                  return _this4._flagRefs[index] = _ref2;
                } },
              serie.flag
            );
          })
        );
      }

      return contents;
    }
  }]);

  return WorldMap;
}(_react.Component);

WorldMap.displayName = 'WorldMap';
exports.default = WorldMap;


WorldMap.propTypes = {
  colorIndex: _propTypes2.default.string,
  // onSelectPlace is passed a place coordinate when the user clicks on it
  onSelectPlace: _propTypes2.default.func,
  // either continent or place must be provided for a series item
  series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    continent: _propTypes2.default.oneOf(CONTINENTS.map(function (c) {
      return c.id;
    })),
    colorIndex: _propTypes2.default.string,
    flag: _propTypes2.default.node,
    label: _propTypes2.default.string, // for a11y aria-label
    onClick: _propTypes2.default.func,
    onHover: _propTypes2.default.func,
    place: _propTypes2.default.arrayOf(_propTypes2.default.number)
  })),
  zoom: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _KeyboardAccelerators = __webpack_require__(510);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Intl = __webpack_require__(568);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(569);

var _Props2 = _interopRequireDefault(_Props);

var _DOM = __webpack_require__(511);

var _SkipLinkAnchor = __webpack_require__(570);

var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);

var _CSSClassnames = __webpack_require__(486);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Announcer = __webpack_require__(571);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.BOX;
var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;

var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box(props) {
    _classCallCheck(this, Box);

    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));

    _this.state = { mouseActive: false };
    return _this;
  }

  _createClass(Box, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var onClick = this.props.onClick;

      if (onClick) {
        var clickCallback = function clickCallback() {
          if (_this2.boxContainerRef === document.activeElement) {
            onClick();
          }
        };

        _KeyboardAccelerators2.default.startListeningToKeyboard(this, {
          enter: clickCallback,
          space: clickCallback
        });
      }

      this._setDarkBackground();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.colorIndex !== this.props.colorIndex) {
        if (nextProps.colorIndex) {
          this.setState({ updateDarkBackground: true });
        } else {
          this.setState({ darkBackground: undefined });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.announce) {
        (0, _Announcer.announce)(this.boxContainerRef.textContent);
      }
      if (this.state.updateDarkBackground) {
        this.setState({ updateDarkBackground: false });
        this._setDarkBackground();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onClick) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
      }
      if (this._checkBackground) {
        this._checkBackground.stop();
      }
    }
  }, {
    key: '_setDarkBackground',
    value: function _setDarkBackground() {
      var _this3 = this;

      var colorIndex = this.props.colorIndex;

      var box = (0, _reactDom.findDOMNode)(this.boxContainerRef);
      if (this._checkBackground) {
        this._checkBackground.stop();
      }
      this._checkBackground = (0, _DOM.checkDarkBackground)(colorIndex, box, function (darkBackground) {
        return _this3.setState({ darkBackground: darkBackground });
      });
    }
  }, {
    key: '_normalize',
    value: function _normalize(string) {
      return string.replace('/', '-');
    }
  }, {
    key: '_addPropertyClass',
    value: function _addPropertyClass(classes, property) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var value = (options.object || this.props)[property];
      var elementName = options.elementName || CLASS_ROOT;
      var prefix = options.prefix || property;
      if (value) {
        if (typeof value === 'string') {
          classes.push(elementName + '--' + prefix + '-' + this._normalize(value));
        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          Object.keys(value).forEach(function (key) {
            _this4._addPropertyClass(classes, key, {
              object: value, prefix: prefix + '-' + key });
          });
        } else {
          classes.push(elementName + '--' + this._normalize(prefix));
        }
      }
    }
  }, {
    key: '_backgroundContextClass',
    value: function _backgroundContextClass(darkBackground) {
      var result = void 0;
      if (undefined === darkBackground) {
        result = BACKGROUND_COLOR_INDEX + '--pending';
      } else if (darkBackground) {
        result = BACKGROUND_COLOR_INDEX + '--dark';
      } else {
        result = BACKGROUND_COLOR_INDEX + '--light';
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          appCentered = _props.appCentered,
          backgroundImage = _props.backgroundImage,
          children = _props.children,
          className = _props.className,
          colorIndex = _props.colorIndex,
          containerClassName = _props.containerClassName,
          focusable = _props.focusable,
          full = _props.full,
          id = _props.id,
          onClick = _props.onClick,
          _onBlur = _props.onBlur,
          _onFocus = _props.onFocus,
          _onMouseDown = _props.onMouseDown,
          _onMouseUp = _props.onMouseUp,
          pad = _props.pad,
          primary = _props.primary,
          role = _props.role,
          size = _props.size,
          tabIndex = _props.tabIndex,
          tag = _props.tag,
          texture = _props.texture;
      var _state = this.state,
          darkBackground = _state.darkBackground,
          mouseActive = _state.mouseActive;

      var classes = [CLASS_ROOT];
      var containerClasses = [CLASS_ROOT + '__container'];
      var restProps = _Props2.default.omit(this.props, Object.keys(Box.propTypes));
      this._addPropertyClass(classes, 'full');
      if (full && full.responsive === undefined) {
        // default is true for backwards compatibility sake
        classes.push(CLASS_ROOT + '--full-responsive');
      }
      this._addPropertyClass(classes, 'direction');
      this._addPropertyClass(classes, 'justify');
      this._addPropertyClass(classes, 'align');
      this._addPropertyClass(classes, 'alignContent', { prefix: 'align-content' });
      this._addPropertyClass(classes, 'alignSelf', { prefix: 'align-self' });
      this._addPropertyClass(classes, 'reverse');
      this._addPropertyClass(classes, 'responsive');
      this._addPropertyClass(classes, 'basis');
      this._addPropertyClass(classes, 'flex');
      this._addPropertyClass(classes, 'pad');
      this._addPropertyClass(classes, 'margin');
      this._addPropertyClass(classes, 'separator');
      this._addPropertyClass(classes, 'textAlign', { prefix: 'text-align' });
      this._addPropertyClass(classes, 'wrap');

      if (this.props.hasOwnProperty('flex')) {
        if (!this.props.flex) {
          classes.push(CLASS_ROOT + '--flex-off');
        }
      }
      if (size) {
        if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
          Object.keys(size).forEach(function (key) {
            _this5._addPropertyClass(classes, key, { object: size });
          });
        } else {
          this._addPropertyClass(classes, 'size');
        }
        if (size) {
          if (!(size.width && size.width.max)) {
            // don't apply 100% max-width when size using size.width.max option
            classes.push(CLASS_ROOT + '--size');
          }
          if (size.width && size.width.max) {
            // allow widths to shrink, apply 100% width
            classes.push(CLASS_ROOT + '--width-max');
          }
        }
      }

      // needed to properly set flex-basis for 1/3 & 2/3 basis boxes
      if (pad && pad.between && children) {
        if (_react2.default.Children.count(children) % 3 === 0) {
          classes.push(CLASS_ROOT + '--pad-between-thirds');
        }
      }

      if (appCentered) {
        this._addPropertyClass(containerClasses, 'full', { elementName: CLASS_ROOT + '__container' });
        if (colorIndex) {
          containerClasses.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
          containerClasses.push(this._backgroundContextClass(darkBackground));
        }
        if (containerClassName) {
          containerClasses.push(containerClassName);
        }
      } else if (colorIndex) {
        classes.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
        classes.push(this._backgroundContextClass(darkBackground));
      }

      var a11yProps = {};
      var clickableProps = {};
      if (onClick) {
        classes.push(CLASS_ROOT + "--clickable");
        clickableProps = {
          onMouseDown: function onMouseDown(event) {
            _this5.setState({ mouseActive: true });
            if (_onMouseDown) {
              _onMouseDown(event);
            }
          },
          onMouseUp: function onMouseUp(event) {
            _this5.setState({ mouseActive: false });
            if (_onMouseUp) {
              _onMouseUp(event);
            }
          },
          onFocus: function onFocus(event) {
            if (mouseActive === false) {
              _this5.setState({ focus: true });
            }
            if (_onFocus) {
              _onFocus(event);
            }
          },
          onBlur: function onBlur(event) {
            _this5.setState({ focus: false });
            if (_onBlur) {
              _onBlur(event);
            }
          }
        };
        if (focusable) {
          if (this.state.focus) {
            classes.push(CLASS_ROOT + '--focus');
          }
          var boxLabel = typeof a11yTitle !== 'undefined' ? a11yTitle : _Intl2.default.getMessage(this.context.intl, 'Box');
          a11yProps.tabIndex = tabIndex || 0;
          a11yProps["aria-label"] = this.props['aria-label'] || boxLabel;
          a11yProps.role = role || 'group';
        }
      }

      var skipLinkAnchor = void 0;
      if (primary) {
        var mainContentLabel = _Intl2.default.getMessage(this.context.intl, 'Main Content');
        skipLinkAnchor = _react2.default.createElement(_SkipLinkAnchor2.default, { label: mainContentLabel });
      }

      if (className) {
        classes.push(className);
      }

      var style = {};
      if (texture && 'string' === typeof texture) {
        if (texture.indexOf('url(') !== -1) {
          style.backgroundImage = texture;
        } else {
          style.backgroundImage = 'url(' + texture + ')';
        }
      } else if (backgroundImage) {
        style.background = backgroundImage + " no-repeat center center";
        style.backgroundSize = "cover";
      }
      style = _extends({}, style, restProps.style);
      var textureMarkup = void 0;
      if ('object' === (typeof texture === 'undefined' ? 'undefined' : _typeof(texture))) {
        textureMarkup = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + "__texture" },
          texture
        );
      }

      var Component = tag;
      if (appCentered) {
        return _react2.default.createElement(
          'div',
          _extends({}, restProps, { ref: function ref(_ref) {
              return _this5.boxContainerRef = _ref;
            },
            className: containerClasses.join(' '),
            style: style, role: role }, a11yProps, clickableProps),
          skipLinkAnchor,
          _react2.default.createElement(
            Component,
            { id: id, className: classes.join(' ') },
            textureMarkup,
            children
          )
        );
      } else {
        return _react2.default.createElement(
          Component,
          _extends({}, restProps, { ref: function ref(_ref2) {
              return _this5.boxContainerRef = _ref2;
            },
            id: id, className: classes.join(' '), style: style,
            role: role, tabIndex: tabIndex,
            onClick: onClick }, a11yProps, clickableProps),
          skipLinkAnchor,
          textureMarkup,
          children
        );
      }
    }
  }]);

  return Box;
}(_react.Component);

Box.displayName = 'Box';
exports.default = Box;


var FIXED_SIZES = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
var RELATIVE_SIZES = ['full', '1/2', '1/3', '2/3', '1/4', '3/4'];
var SIZES = FIXED_SIZES.concat(RELATIVE_SIZES);
var MARGIN_SIZES = ['small', 'medium', 'large', 'none'];
var PAD_SIZES = ['small', 'medium', 'large', 'xlarge', 'none'];

Box.propTypes = {
  a11yTitle: _propTypes2.default.string,
  announce: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
  alignContent: _propTypes2.default.oneOf(['start', 'center', 'end', 'between', 'around', 'stretch']),
  alignSelf: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
  appCentered: _propTypes2.default.bool,
  backgroundImage: _propTypes2.default.string,
  basis: _propTypes2.default.oneOf(SIZES),
  colorIndex: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['row', 'column']),
  focusable: _propTypes2.default.bool,
  flex: _propTypes2.default.oneOf(['grow', 'shrink', true, false]),
  full: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.shape({
    vertical: _propTypes2.default.bool,
    horizontal: _propTypes2.default.bool,
    responsive: _propTypes2.default.bool
  })]),
  // remove in 1.0?
  onClick: _propTypes2.default.func,
  justify: _propTypes2.default.oneOf(['start', 'center', 'between', 'end', 'around']),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(MARGIN_SIZES), _propTypes2.default.shape({
    bottom: _propTypes2.default.oneOf(MARGIN_SIZES),
    horizontal: _propTypes2.default.oneOf(MARGIN_SIZES),
    left: _propTypes2.default.oneOf(MARGIN_SIZES),
    right: _propTypes2.default.oneOf(MARGIN_SIZES),
    top: _propTypes2.default.oneOf(MARGIN_SIZES),
    vertical: _propTypes2.default.oneOf(MARGIN_SIZES)
  })]),
  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(PAD_SIZES), _propTypes2.default.shape({
    between: _propTypes2.default.oneOf(PAD_SIZES),
    horizontal: _propTypes2.default.oneOf(PAD_SIZES),
    vertical: _propTypes2.default.oneOf(PAD_SIZES)
  })]),
  primary: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  responsive: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  separator: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right', 'horizontal', 'vertical', 'all', 'none']),
  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'full']), // remove in 1.0?, use basis
  _propTypes2.default.shape({
    height: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
      max: _propTypes2.default.oneOf(FIXED_SIZES),
      min: _propTypes2.default.oneOf(FIXED_SIZES)
    })]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
      max: _propTypes2.default.oneOf(FIXED_SIZES),
      min: _propTypes2.default.oneOf(FIXED_SIZES)
    })])
  })]),
  tag: _propTypes2.default.string,
  textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
  texture: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  wrap: _propTypes2.default.bool
};

Box.contextTypes = {
  intl: _propTypes2.default.object
};

Box.defaultProps = {
  announce: false,
  direction: 'column',
  pad: 'none',
  tag: 'div',
  responsive: true,
  focusable: true
};
module.exports = exports['default'];

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
exports.default = {
  getMessage: function getMessage(intl, key, values, defaultMessage) {
    if (intl) {
      return intl.formatMessage({
        id: key,
        defaultMessage: defaultMessage || key
      }, values);
    } else {
      return key;
    }
  }
};
module.exports = exports["default"];

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.default = {
  pick: function pick(props, fields) {
    var has = function has(p) {
      return props.hasOwnProperty(p);
    };
    var obj = {};
    (fields || []).forEach(function (field) {
      if (has(field)) obj[field] = props[field];
    });
    return obj;
  },
  omit: function omit(props, fields) {
    var obj = {};
    Object.keys(props).forEach(function (p) {
      if ((fields || []).indexOf(p) === -1) {
        obj[p] = props[p];
      }
    });
    return obj;
  }
};
module.exports = exports["default"];

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSClassnames = __webpack_require__(486);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;

var SkipLinkAnchor = function (_Component) {
  _inherits(SkipLinkAnchor, _Component);

  function SkipLinkAnchor() {
    _classCallCheck(this, SkipLinkAnchor);

    return _possibleConstructorReturn(this, (SkipLinkAnchor.__proto__ || Object.getPrototypeOf(SkipLinkAnchor)).apply(this, arguments));
  }

  _createClass(SkipLinkAnchor, [{
    key: 'render',
    value: function render() {
      var id = 'skip-link-' + this.props.label.toLowerCase().replace(/ /g, '_');

      return _react2.default.createElement(
        'a',
        { tabIndex: '-1', 'aria-hidden': 'true', id: id, className: CLASS_ROOT },
        this.props.label
      );
    }
  }]);

  return SkipLinkAnchor;
}(_react.Component);

SkipLinkAnchor.displayName = 'SkipLinkAnchor';
exports.default = SkipLinkAnchor;


SkipLinkAnchor.propTypes = {
  label: _propTypes2.default.node.isRequired
};
module.exports = exports['default'];

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.announcePageLoaded = announcePageLoaded;
exports.announce = announce;

var _CSSClassnames = __webpack_require__(486);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_ROOT = _CSSClassnames2.default.APP; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

function clearAnnouncer() {
  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
  if (announcer) {
    announcer.innerHTML = '';
  }
};

function announcePageLoaded(title) {
  announce(title + ' page was loaded');
}

function announce(message) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';

  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
  if (announcer) {
    announcer.setAttribute('aria-live', 'off');
    announcer.innerHTML = message;
    setTimeout(clearAnnouncer, 500);
    announcer.setAttribute('aria-live', mode);
  }
}

exports.default = { announce: announce, announcePageLoaded: announcePageLoaded };

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gITDzEb6FAyWwAAASdJREFUKM+d07FKHFEUxvHfXE3UztgJAfMCluviYKZI5TukMJAqkkeYRtjXsBF8Aq1FRrNxMltGSCVYqNhMJSJsYFN4thR38jW3uf97z3fOd7K2ya30hqAY9JfQwxds4B1a1DjAqCrrx7bJQSZUDPrr2MM2HjHGBAnzWMQxBlVZ/26b/BkOcB8f8NfLeosr7FZlPcqi1ENsvQJOleEnvqbwtj0jKKzk2ErYCY9d9AbF9OdxR3iMPMU4Jh3hCVZTzDF1hDPcpQjA/H94Pk+RnMWO8BPOEkY4igDMWvIvnM5dn9yM1z69/4MCyzOA9/helfVNaptcVdaX+IYfcWEhmpjFuRAdvsDnqqwv2yaXTTdkpTdUDPrLEdOP2MQqbjGMh0+rsn6YbuI/tkVZaZpqf9oAAAAASUVORK5CYII="

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gITDy4TK9G09wAAAQ1JREFUKM+d070uBVEUxfHfnPi4OqbTiF6UI3GC2jsoSFS8hcRrUEg8AQ8gwfiYW9IqiWYqEcmVXIU9pTBWc5rz3+esvdcu2iYrqxq0TZ5BhR2sYA4t7nCCYVnV722TQSHUNnkZB9jEO0YYI2ECA5zjsKzqh7bJ33CAR1jEp581hSfsl1U9LOKrp1j7BexU4Aa7Kbxt/hEUVjLWErbDYx9NYqN7edQTHiGnGMe4JzzGfIo5pp5wgZcUAZj4h+erFMkZ9IQ/cJkwxFkE4K9fvsdFl7AlHGPhl+YVeMVWWdWPKRbjEXu4jgvT0cQizukoetuBbZMV3YaUVa1t8mzEdB2rmMcz6ih8UVb1W7eJX+RxVgnMLW3mAAAAAElFTkSuQmCC"

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(12);

var _reactRedux = __webpack_require__(15);

var _storyblokReact = __webpack_require__(30);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

var _reactHelmet = __webpack_require__(31);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _WorldMap = __webpack_require__(566);

var _WorldMap2 = _interopRequireDefault(_WorldMap);

var _Box = __webpack_require__(567);

var _Box2 = _interopRequireDefault(_Box);

__webpack_require__(572);

__webpack_require__(573);

var _close = __webpack_require__(499);

var _close2 = _interopRequireDefault(_close);

var _green_marker = __webpack_require__(574);

var _green_marker2 = _interopRequireDefault(_green_marker);

var _yellow_marker = __webpack_require__(575);

var _yellow_marker2 = _interopRequireDefault(_yellow_marker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var converter = new _showdown2.default.Converter();

var SpecialProjectPopupComp = function SpecialProjectPopupComp(_ref) {
  var closePopup = _ref.closePopup,
      project = _ref.project,
      lng = _ref.lng;
  return _react2.default.createElement(
    'div',
    { className: 'popup' },
    _react2.default.createElement('img', { className: 'closeIcon', src: _close2.default, alt: '', onClick: closePopup, onKeyPress: closePopup }),
    _react2.default.createElement(
      'h1',
      { className: 'projectTitle' },
      project.name
    ),
    project.special_projects.map(function (el) {
      return _react2.default.createElement(
        'div',
        { className: 'project', key: el._uid },
        el.logo && _react2.default.createElement('img', { src: el.logo, alt: 'project logo' }),
        el.Organization && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'projectLabel' },
            lng === 'en' ? 'Organization' : 'Organización',
            ': '
          ),
          el.Organization
        ),
        el.Location && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'projectLabel' },
            lng === 'en' ? 'Location' : 'Ubicación',
            ': '
          ),
          el.Location
        ),
        el.Objectives && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'projectLabel' },
            lng === 'en' ? 'Objectives' : 'Objetivos',
            ': '
          ),
          _react2.default.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: converter.makeHtml(el.Objectives)
            }
          })
        ),
        el.Started && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'projectLabel' },
            lng === 'en' ? 'Started' : 'Inicio',
            ': '
          ),
          el.Started
        ),
        el.Contacts && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'projectLabel' },
            lng === 'en' ? 'Contact info' : 'Contacto',
            ': '
          ),
          el.Contacts
        )
      );
    })
  );
};

var SpecialProjectPopup = (0, _reactRedux.connect)(function (_ref2) {
  var lng = _ref2.lng;
  return {
    lng: lng
  };
})(SpecialProjectPopupComp);

var Hub = function Hub(_ref3) {
  var el = _ref3.el,
      selectSpecialProject = _ref3.selectSpecialProject;
  return _react2.default.createElement(
    'div',
    {
      style: { backgroundImage: 'url(' + el.image + ')' },
      className: 'hubs__item hubs__item--image',
      onClick: function onClick() {
        return selectSpecialProject(el);
      },
      onKeyPress: function onKeyPress() {
        return selectSpecialProject(el);
      }
    },
    _react2.default.createElement(
      'div',
      { className: 'bold heading--big' },
      el.name
    ),
    _react2.default.createElement('i', { className: 'icon-arrow-circle' })
  );
};

var WhereWeWork = function (_Component) {
  _inherits(WhereWeWork, _Component);

  function WhereWeWork(props) {
    _classCallCheck(this, WhereWeWork);

    var _this = _possibleConstructorReturn(this, (WhereWeWork.__proto__ || Object.getPrototypeOf(WhereWeWork)).call(this, props));

    _this.onClick = function (place) {
      if (place.special_project) {
        document.getElementById('whatisaspecialproject').scrollIntoView({ behavior: 'smooth' });
      } else if (typeof window !== 'undefined') {
        window.open(place.link, '_blank').focus();
      }
    };

    _this.closePopup = function () {
      _this.setState({
        selectedSpecialProject: false
      });
    };

    _this.selectSpecialProject = function (project) {
      if (project.special_projects) {
        _this.setState({
          selectedSpecialProject: project
        });
      }
    };

    _this.onHover = function (tooltip, place) {
      _this.setState({
        hoveredPlace: tooltip ? place : false
      });
    };

    _this.state = {
      hoveredPlace: false,
      selectedSpecialProject: false
    };
    return _this;
  }

  _createClass(WhereWeWork, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var content = this.props.story.content;
      var _state = this.state,
          hoveredPlace = _state.hoveredPlace,
          selectedSpecialProject = _state.selectedSpecialProject;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            'title',
            null,
            content && content.top[0].title
          )
        ),
        selectedSpecialProject && _react2.default.createElement(SpecialProjectPopup, { project: selectedSpecialProject, closePopup: this.closePopup }),
        content && content.top.map(function (el) {
          return _react2.default.createElement(
            'div',
            {
              key: el._uid,
              className: 'hero hero--small',
              style: {
                backgroundImage: 'url(' + el.image + ')',
                backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
              }
            },
            _react2.default.createElement('div', { className: 'hero__overlay' }),
            _react2.default.createElement(
              'div',
              { className: 'wrapper' },
              _react2.default.createElement(
                _storyblokReact2.default,
                { content: el },
                _react2.default.createElement(
                  'h1',
                  { className: 'hero__title hero--small__title' },
                  el.title
                )
              )
            )
          );
        }),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'where-we-work__map' },
            content.map.filter(function (el) {
              return el.component === 'Text';
            }).map(function (el) {
              return _react2.default.createElement(
                _storyblokReact2.default,
                { key: el._uid, content: el },
                _react2.default.createElement(
                  'p',
                  { className: 'heading--small' },
                  el.text || 'Poverty Stoplight hubs & Special Projects'
                )
              );
            }),
            _react2.default.createElement(
              'div',
              { className: 'map-dots' },
              _react2.default.createElement(_WorldMap2.default, {
                colorIndex: 'unset',
                series: content.map.filter(function (el) {
                  return el.component === 'Hubs List';
                })[0].list.filter(function (place) {
                  return place.component === 'Hub' && place.latitude && place.longitude;
                }).map(function (place) {
                  return {
                    place: [place.latitude ? Number(place.latitude) : 0, place.longitude ? Number(place.longitude) : 0],
                    colorIndex: place.special_project ? 'warning' : 'ok',
                    label: place.name,
                    flag: _react2.default.createElement(
                      _Box2.default,
                      {
                        pad: 'small',
                        colorIndex: 'grey-2',
                        style: {
                          opacity: hoveredPlace && hoveredPlace.name === place.name ? '1' : '0'
                        }
                      },
                      place.name
                    ),
                    onHover: function onHover(tooltip) {
                      return _this2.onHover(tooltip, place);
                    },
                    onClick: function onClick() {
                      return _this2.onClick(place);
                    }
                  };
                })
              }),
              content.map.filter(function (el) {
                return el.component === 'Map Legend';
              }).map(function (el) {
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement(
                    'p',
                    { className: 'map_legend' },
                    _react2.default.createElement('img', { src: _green_marker2.default, alt: 'hub marker' }),
                    ' ',
                    _react2.default.createElement(
                      'span',
                      null,
                      el.hub_label
                    ),
                    _react2.default.createElement('img', { src: _yellow_marker2.default, alt: 'special project marker' }),
                    ' ',
                    _react2.default.createElement(
                      'span',
                      null,
                      el.special_project_label
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'background--gray' },
          _react2.default.createElement(
            'div',
            { className: 'wrapper wrapper--flex pt-120' },
            content.map.filter(function (el) {
              return el.component === 'Hubs List';
            })[0].list.map(function (el) {
              switch (el.component) {
                case 'Hub':
                  return _react2.default.createElement(
                    _storyblokReact2.default,
                    { key: el._uid, content: el },
                    el.special_projects ? _react2.default.createElement(Hub, { el: el, selectSpecialProject: _this2.selectSpecialProject }) : _react2.default.createElement(
                      'a',
                      { className: 'hubs__link', href: el.link, target: '_blank', rel: 'noopener noreferrer' },
                      _react2.default.createElement(Hub, { el: el, selectSpecialProject: _this2.selectSpecialProject })
                    )
                  );
                case 'Become Hub':
                  return _react2.default.createElement(
                    _storyblokReact2.default,
                    { key: el._uid, content: el },
                    _react2.default.createElement(
                      'div',
                      { className: 'hubs__item hubs__item--become-hub' },
                      _react2.default.createElement(
                        'div',
                        { className: 'heading--small bold' },
                        el.title
                      ),
                      _react2.default.createElement(
                        _reactStatic.Link,
                        {
                          to: '/' + el.link[0].link.cached_url + '#' + el.id,
                          className: 'button button--outline button--arrow hubs__button'
                        },
                        _react2.default.createElement(
                          'div',
                          null,
                          el.link[0].label
                        ),
                        _react2.default.createElement('span', { className: 'icon-button-arrow' })
                      )
                    )
                  );
                default:
                  return '';
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement('div', { className: 'line' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'partnership' },
            _react2.default.createElement(
              'div',
              { className: 'background--gray' },
              _react2.default.createElement(
                'div',
                { className: 'wrapper' },
                content.partnership.map(function (el) {
                  switch (el.component) {
                    case 'Section Title':
                      return _react2.default.createElement(
                        _storyblokReact2.default,
                        { key: el._uid, content: el },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-1-3' },
                          _react2.default.createElement(
                            'div',
                            { className: 'bold heading--big' },
                            el.text
                          )
                        )
                      );
                    case 'Rich Text':
                      return _react2.default.createElement(
                        _storyblokReact2.default,
                        { key: el._uid, content: el },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-2-3' },
                          _react2.default.createElement('div', {
                            className: 'paragraph--sans rich-text',
                            dangerouslySetInnerHTML: {
                              __html: converter.makeHtml(el.markdown)
                            }
                          })
                        )
                      );

                    default:
                      return '';
                  }
                })
              )
            )
          )
        )
      );
    }
  }]);

  return WhereWeWork;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(WhereWeWork);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/WhereWeWork.6a3c0595.js